<div class="business-content loyalty-page-container">
  <div class="text-center finish-loyalty-container">
    <p class="enroll-finish-msg" i18n="@@loyalty-finish-form.loyaltyFinishRegistrationAllSetThankYou">
      Now you are all set! Thank you for joining Amadeus+Me.
    </p>
    <p class="enroll-finish-msg">
      {{finishRegistrationMessage}}<span id="agentNumber">&nbsp;{{ agentState.data.number }}</span>
    </p>

    <div *ngIf="!agentState.isLoading" class="input_container">
      <button
        class="btn btn-primary reg-finish-message"
        type="submit"
        id="finish"
        style="width: 100%;"
        (click)="finishRegistration()"
        i18n="@@loyalty-finish-form.loyaltyInnerPageStartNowButton"
      >
        Start now
      </button>
    </div>
  </div>
</div>
